import {ChangeDetectionStrategy, Component, computed, effect, input, signal, ViewEncapsulation} from '@angular/core';
import {UrlBuilderService} from '../../../../services/url-builder.service';
import {WPTag} from '../../../../types/WPTag';
import {WPTagToDisplay} from '../../../../types/WPTagToDisplay';
import {WPPostGuide} from '../../../../types/WPPostGuide';

@Component({
  selector: 'app-guide-taxonomy-box',
  templateUrl: './guide-taxonomy-box.component.html',
  styleUrls: ['./guide-taxonomy-box.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuideTaxonomyBoxComponent {
  tag = input<WPTag>();
  puffsLimit = input<number>();
  puffsPreloaded = input<WPPostGuide[]>();
  numberOfPriorityPuffs = input<number>(1);
  public tagToDisplay = signal<WPTagToDisplay>(null);
  public isMoreBtnVisible = computed<boolean>(() => {
    return this.puffsPreloaded() && this.puffsPreloaded().length >= this.puffsLimit();
  });

  constructor(private urlBuilder: UrlBuilderService) {
    effect(
      () => {
        if (this.tag()) {
          this.tagToDisplay.set({
            ...this.tag(),
            routerLink: this.urlBuilder.CreateGuideTagRouterLink(this.tag().slug),
            anchor: this.tag().name,
          });
        }
      },
      {allowSignalWrites: true},
    );
  }
}
